import React from 'react';
import * as S from './ReviewGoTribe.styles';
import marked from 'marked'

type GoTribeProps = {
  icon?: string;
  msg?: string;
};

const ReviewGoTribe = (data: GoTribeProps) => {

  const { icon, msg } = data;

  return (
    <section style={{ marginTop: '1.5rem' }}>
      <S.GoTribeTag>
        <S.IconWrap>
          <img src={icon} alt="goTribe" />
        </S.IconWrap>
        <S.Text dangerouslySetInnerHTML={{ __html: marked(msg) }}></S.Text>
      </S.GoTribeTag>
    </section>
  );
}

export default ReviewGoTribe;
